import React, { useContext, useState } from 'react';
import * as S from './styled';
import { ValidityContext } from '../../../../../provider/ValidityProvider';
import Form from '../../..';
import { getFilterColumn, setFilterColumn } from '../../../../../store/utils';
import DateFilter from '../../../../DateFilter';

export default function FormValidityFilter() {
  const {
    autocompleteValidities,
    getValidity,
    setValidity,
    searchFilter,
    setSearchFilter,
    priorityItems,
  } = useContext(ValidityContext)!.controllers.validity;

  const autocompletes = getValidity('autocompletes.validity');

  const [codeLoading, setCodeLoading] = useState(false);
  const [productLoading, setProductLoading] = useState(false);
  const [barcodeLoading, setBarcodeLoading] = useState(false);
  const [sectionLoading, setSectionLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  const [branchLoading, setBranchLoading] = useState(false);

  const autocompleteCode = (e) => {
    setCodeLoading(true);
    autocompleteValidities('subProductId', e.target.value)
      .then((data) => {
        setValidity(`autocompletes.validity.code.data`, data);
      })
      .finally(() => {
        setCodeLoading(false);
      });
  };

  const autocompleteProduct = (e) => {
    setProductLoading(true);
    autocompleteValidities('productShortDescription', e.target.value)
      .then((data) => {
        setValidity(`autocompletes.validity.product.data`, data);
      })
      .finally(() => {
        setProductLoading(false);
      });
  };

  const autocompleteBarcode = (e) => {
    setBarcodeLoading(true);
    autocompleteValidities('barcodeNumber', e.target.value)
      .then((data) => {
        setValidity(`autocompletes.validity.barcode.data`, data);
      })
      .finally(() => {
        setBarcodeLoading(false);
      });
  };

  const autocompleteSection = (e) => {
    setSectionLoading(true);
    autocompleteValidities('sectionDescription', e.target.value, 'sectionId')
      .then((data) => {
        setValidity(`autocompletes.validity.section.data`, data);
      })
      .finally(() => {
        setSectionLoading(false);
      });
  };

  const autocompleteStatus = (e) => {
    setStatusLoading(true);
    autocompleteValidities('statusName', e.target.value)
      .then((data) => {
        setValidity(`autocompletes.validity.statusName.data`, data);
      })
      .finally(() => {
        setStatusLoading(false);
      });
  };

  const autocompleteBranch = (e) => {
    setBranchLoading(true);
    autocompleteValidities('branchName', e.target.value, 'branchCode')
      .then((data) => {
        setValidity(`autocompletes.validity.branch.data`, data);
      })
      .finally(() => {
        setBranchLoading(false);
      });
  };

  const codeItems = autocompletes.code.data?.map((item) => ({
    id: item.id,
    name: `${item.value}`,
    data: item,
  }));

  const productItems = autocompletes.product.data?.map((item) => ({
    id: item.id,
    name: `${item.value}`,
    data: item,
  }));

  const barcodeItems = autocompletes.barcode.data?.map((item) => ({
    id: item.id,
    name: `${item.value}`,
    data: item,
  }));

  const sectionItems = autocompletes.section.data?.map((item) => ({
    id: item.id,
    name: `${item.id} - ${item.value}`,
    data: item,
  }));

  const statusItems = autocompletes.statusName.data?.map((item) => ({
    id: item.id,
    name: `${item.value}`,
    data: item,
  }));

  const branchItems = autocompletes.branch.data?.map((item) => ({
    id: item.id,
    name: `${item.id} - ${item.value}`,
    data: item,
  }));

  const codeValue = getFilterColumn('subProductId', searchFilter, 'LIKE');

  const productShortDescriptionValue = getFilterColumn(
    'productShortDescription',
    searchFilter,
    'LIKE',
  );

  const barcodeValue = getFilterColumn('barcodeNumber', searchFilter, 'LIKE');

  const sectionDescriptionValue = getFilterColumn(
    'sectionDescription',
    searchFilter,
    'LIKE',
  );

  const statusValue = getFilterColumn('statusName', searchFilter, 'LIKE');

  const branchNameValue = getFilterColumn('branchName', searchFilter, 'LIKE');
  
  const priorityFilter = getFilterColumn('priority', searchFilter);
  const priorityValue =
    priorityItems.find(({ data }) => data === priorityFilter)?.name ?? '';

  const getFilterField = (field: string, operator?: OPERATOR) =>
    getFilterColumn(field, searchFilter, operator);

  const setFilterField =
    (field: string, operator?: OPERATOR, format?: string) => (e) => {
      let filter = setFilterColumn(
        field,
        e.target.value,
        searchFilter,
        operator,
        'AND',
        format,
      );
      setSearchFilter({
        ...filter,
        page: 1,
      });
    };
  const setField =
    (field: any, operator?: OPERATOR, format?: string) => (e) => {
      setFilterField(field, operator, format)(e);
    };

  return (
    <S.Form>
      <S.Body>
        <S.BodyContainer>
          <S.Field>
            <Form.Input.Dropdown
              label="Código"
              items={codeItems}
              value={`${codeValue}`}
              onDebouncedChange={autocompleteCode}
              errorMessage={false}
              onChange={(e) => {
                const value = e.target.value;
                let filter = setFilterColumn(
                  'subProductId',
                  value,
                  searchFilter,
                  'LIKE',
                  'AND',
                );
                setSearchFilter(filter);
              }}
              onFocus={() => {
                let filter = setFilterColumn(
                  'subProductId',
                  '',
                  searchFilter,
                  'LIKE',
                );
                setSearchFilter(filter);
              }}
              onSelected={({ data }) => {
                let filter = setFilterColumn(
                  'subProductId',
                  data.value,
                  searchFilter,
                  'LIKE',
                  'AND',
                );
                setSearchFilter(filter);
              }}
              hasClearItem
              loading={codeLoading}
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="Produto"
              items={productItems}
              value={`${productShortDescriptionValue}`}
              onDebouncedChange={autocompleteProduct}
              errorMessage={false}
              onChange={(e) => {
                const value = e.target.value;
                let filter = setFilterColumn(
                  'productShortDescription',
                  value,
                  searchFilter,
                  'LIKE',
                  'AND',
                );
                setSearchFilter(filter);
              }}
              onFocus={() => {
                let filter = setFilterColumn(
                  'productShortDescription',
                  '',
                  searchFilter,
                  'LIKE',
                );
                setSearchFilter(filter);
              }}
              onSelected={({ data }) => {
                let filter = setFilterColumn(
                  'productShortDescription',
                  data.value,
                  searchFilter,
                  'LIKE',
                  'AND',
                );
                setSearchFilter(filter);
              }}
              hasClearItem
              loading={productLoading}
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="Código de barras"
              items={barcodeItems}
              value={`${barcodeValue}`}
              onDebouncedChange={autocompleteBarcode}
              errorMessage={false}
              onChange={(e) => {
                const value = e.target.value;
                let filter = setFilterColumn(
                  'barcodeNumber',
                  value,
                  searchFilter,
                  'LIKE',
                  'AND',
                );
                setSearchFilter(filter);
              }}
              onFocus={() => {
                let filter = setFilterColumn(
                  'barcodeNumber',
                  '',
                  searchFilter,
                  'LIKE',
                );
                setSearchFilter(filter);
              }}
              onSelected={({ data }) => {
                let filter = setFilterColumn(
                  'barcodeNumber',
                  data.value,
                  searchFilter,
                  'LIKE',
                  'AND',
                );
                setSearchFilter(filter);
              }}
              hasClearItem
              loading={barcodeLoading}
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="Seção"
              items={sectionItems}
              value={`${sectionDescriptionValue}`}
              errorMessage={false}
              onDebouncedChange={autocompleteSection}
              onChange={(e) => {
                const value = e.target.value;
                let filter = setFilterColumn(
                  'sectionDescription',
                  value,
                  searchFilter,
                  'LIKE',
                  'OR',
                );
                filter = setFilterColumn(
                  'sectionId',
                  value,
                  filter,
                  'LIKE',
                  'OR',
                );
                setSearchFilter(filter);
              }}
              onFocus={() => {
                let filter = setFilterColumn(
                  'sectionDescription',
                  '',
                  searchFilter,
                  'LIKE',
                );
                filter = setFilterColumn('sectionId', '', filter, 'LIKE');
                setSearchFilter(filter);
              }}
              onSelected={({ data }) => {
                let filter = setFilterColumn(
                  'sectionDescription',
                  data.value,
                  searchFilter,
                  'LIKE',
                  'AND',
                );
                filter = setFilterColumn(
                  'sectionId',
                  data.id,
                  filter,
                  'LIKE',
                  'AND',
                );

                setSearchFilter({ ...filter, page: 1 });
              }}
              hasClearItem
              loading={sectionLoading}
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="Status"
              items={statusItems}
              value={`${statusValue}`}
              errorMessage={false}
              onDebouncedChange={autocompleteStatus}
              onChange={(e) => {
                const value = e.target.value;
                let filter = setFilterColumn(
                  'statusName',
                  value,
                  searchFilter,
                  'LIKE',
                  'OR',
                );
                setSearchFilter(filter);
              }}
              onFocus={() => {
                let filter = setFilterColumn(
                  'statusName',
                  '',
                  searchFilter,
                  'LIKE',
                );
                setSearchFilter(filter);
              }}
              onSelected={({ data }) => {
                let filter = setFilterColumn(
                  'statusName',
                  data.value,
                  searchFilter,
                  'LIKE',
                  'AND',
                );
                setSearchFilter(filter);
              }}
              hasClearItem
              loading={statusLoading}
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="Filial"
              items={branchItems}
              value={`${branchNameValue}`}
              errorMessage={false}
              onDebouncedChange={autocompleteBranch}
              onChange={(e) => {
                const value = e.target.value;
                let filter = setFilterColumn(
                  'branchName',
                  value,
                  searchFilter,
                  'LIKE',
                  'OR',
                );
                filter = setFilterColumn(
                  'branchCode',
                  value,
                  filter,
                  'LIKE',
                  'OR',
                );
                setSearchFilter(filter);
              }}
              onFocus={() => {
                let filter = setFilterColumn(
                  'branchName',
                  '',
                  searchFilter,
                  'LIKE',
                );
                filter = setFilterColumn('branchCode', '', filter, 'LIKE');
                setSearchFilter(filter);
              }}
              onSelected={({ data }) => {
                let filter = setFilterColumn(
                  'branchName',
                  data.value,
                  searchFilter,
                  'LIKE',
                  'AND',
                );
                filter = setFilterColumn(
                  'branchCode',
                  data.id,
                  filter,
                  'LIKE',
                  'AND',
                );

                setSearchFilter(filter);
              }}
              hasClearItem
              loading={branchLoading}
            />
          </S.Field>

          <S.Field>
            <Form.Input.Dropdown
              label="Prioridade"
              items={priorityItems}
              value={`${priorityValue}`}
              errorMessage={false}
              onChange={() => {}}
              onFocus={() => {
                let filter = setFilterColumn('priority', '', searchFilter);
                setSearchFilter(filter);
              }}
              onSelected={({ data }) => {
                let filter = setFilterColumn(
                  'priority',
                  data,
                  searchFilter,
                  'LIKE',
                  'AND',
                );
                setSearchFilter(filter);
              }}
              hasClearItem
              loading={statusLoading}
            />
          </S.Field>

          <S.DateContainer>
            <S.Label>Validade</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getFilterField('validity', 'GTE') as string}
                onChange={setField('validity', 'GTE', 'dd/MM/yyyy')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getFilterField('validity', 'LTE') as string}
                onChange={setField('validity', 'LTE', 'dd/MM/yyyy')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getFilterField('validity', 'GTE') as string}
              finalDate={getFilterField('validity', 'LTE') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'validity',
                  initialDate,
                  searchFilter,
                  'GTE',
                  'AND',
                  'dd/MM/yyyy',
                );
                filter = setFilterColumn(
                  'validity',
                  finalDate,
                  filter,
                  'LTE',
                  'AND',
                  'dd/MM/yyyy',
                );
                setSearchFilter(filter);
              }}
            />
          </S.DateContainer>

          <S.DateContainer>
            <S.Label>Data de criação</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getFilterField('createdAt', 'GTE') as string}
                onChange={setField('createdAt', 'GTE', 'dd/MM/yyyy')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getFilterField('createdAt', 'LTE') as string}
                onChange={setField('createdAt', 'LTE', 'dd/MM/yyyy')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getFilterField('createdAt', 'GTE') as string}
              finalDate={getFilterField('createdAt', 'LTE') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'createdAt',
                  initialDate,
                  searchFilter,
                  'GTE',
                  'AND',
                  'dd/MM/yyyy',
                );
                filter = setFilterColumn(
                  'createdAt',
                  finalDate,
                  filter,
                  'LTE',
                  'AND',
                  'dd/MM/yyyy',
                );
                setSearchFilter(filter);
              }}
            />
          </S.DateContainer>

          <S.DateContainer>
            <S.Label>Data de atualização</S.Label>
            <S.Row>
              <Form.Input.DatePicker
                label={'Data inicial'}
                value={getFilterField('updatedAt', 'GTE') as string}
                onChange={setField('updatedAt', 'GTE', 'dd/MM/yyyy')}
                errorMessage={false}
              />
              <Form.Input.DatePicker
                label={'Data final'}
                value={getFilterField('updatedAt', 'LTE') as string}
                onChange={setField('updatedAt', 'LTE', 'dd/MM/yyyy')}
                errorMessage={false}
              />
            </S.Row>
            <DateFilter
              initialDate={getFilterField('updatedAt', 'GTE') as string}
              finalDate={getFilterField('updatedAt', 'LTE') as string}
              onRangeSelect={(initialDate, finalDate) => {
                let filter = setFilterColumn(
                  'updatedAt',
                  initialDate,
                  searchFilter,
                  'GTE',
                  'AND',
                  'dd/MM/yyyy',
                );
                filter = setFilterColumn(
                  'updatedAt',
                  finalDate,
                  filter,
                  'LTE',
                  'AND',
                  'dd/MM/yyyy',
                );
                setSearchFilter(filter);
              }}
            />
          </S.DateContainer>
        </S.BodyContainer>
      </S.Body>
      <S.ClearButton
        onClick={(e) => {
          e.preventDefault();
          setValidity('filters.validities.filter.filter', []);
        }}
      >
        Limpar
      </S.ClearButton>
    </S.Form>
  );
}
